var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c(
        "cargo-left-right-resize",
        {
          attrs: {
            "left-style": { width: "336px", flex: "unset" },
            "right-style": { "flex-grow": "1" }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c(
              "div",
              { staticClass: "section", staticStyle: { height: "100%" } },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.roleList")))
                ]),
                _c("cargo-ag-grid", {
                  class: _vm.currentState === _vm.EDITING ? "shadow" : "",
                  staticStyle: { height: "100%" },
                  attrs: {
                    "grid-options": _vm.officeDeptTree.gridOptions,
                    "column-defs": _vm.officeDeptTree.columnDefs,
                    "row-data": _vm.officeDeptTree.rowData,
                    "show-side-bar": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.officeDeptTree.gridApi = params.api
                    }
                  }
                }),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "5px" } },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentState === _vm.NORMAL,
                            expression: "currentState===NORMAL"
                          }
                        ],
                        staticStyle: { float: "right" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.currentState = _vm.EDITING
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentState === _vm.EDITING,
                            expression: "currentState===EDITING"
                          }
                        ],
                        staticStyle: { float: "right" }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.save }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "cargo-left-right-resize",
                { staticStyle: { height: "100%" } },
                [
                  _c("template", { slot: "left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section",
                        staticStyle: { height: "100%" }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.assignedResponsibilities"))
                          )
                        ]),
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%", width: "100%" },
                          attrs: {
                            "grid-options": _vm.ora.gridOptions,
                            "column-defs": _vm.ora.columnDefs,
                            "row-data": _vm.ora.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.ora.gridApi = params.api
                            }
                          }
                        }),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { float: "right" },
                                attrs: {
                                  disabled: !(
                                    _vm.currentState === _vm.EDITING &&
                                    _vm.ora.selectedNode
                                  ),
                                  type: "primary"
                                },
                                on: { click: _vm.remove }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Remove")) + ">"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section",
                        staticStyle: { height: "100%" }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.listOfResponsibilities"))
                          )
                        ]),
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%", width: "100%" },
                          attrs: {
                            "grid-options": _vm.ors.gridOptions,
                            "column-defs": _vm.ors.columnDefs,
                            "row-data": _vm.ors.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.ors.gridApi = params.api
                            }
                          }
                        }),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !(
                                    _vm.currentState === _vm.EDITING &&
                                    _vm.ors.selectedNode
                                  ),
                                  type: "primary"
                                },
                                on: { click: _vm.add }
                              },
                              [
                                _vm._v(
                                  "<" + _vm._s(_vm.$t("CargoMsg.Cargo_add"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }